/**
 * Created by yz on 2017/6/5.
 *
 * 用于保存全局信息
 */
{
    angular.module('utilsModule')
        .factory('utils.global', global);
    global.$inject = [];
    function global() {
        let collect = {
            'printSettingsData':null,
            'areaid':null,
            'areaname':null
        }

        return collect;
    }

}